import React, { useState, useEffect } from "react";
import {useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import "./Spinner.css";
import "react-toastify/dist/ReactToastify.css";
import { Modal, Button, Form } from "react-bootstrap";

const CancelDoctorAppointment = ({ isOpen, onRequestClose, doctorAppointmentId }) => {

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
  
  }, []);

  const cancelAppointment = async (appointmentId) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    setLoading(true);
    try {
      await axios.post(
        "/api/doctorappointment/accept-or-reschedule-or-cancel",
        {
          id: `${appointmentId}`,
          appointmentstatus: "APPOINTMENT CANCELLED",
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success("Appointment cancelled successfully.");
      onRequestClose(); // Close the modal
    } catch (error) {
    setLoading(false);
      handleError(error);
 
    }
  };


  const handleConfirmCancel = async () => {
      cancelAppointment(doctorAppointmentId);
  };

  const handleError = (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && typeof error.response.data === 'string') {
        toast.error(error.response.data);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  };
  
  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
       Cancel Appointment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading && <div className="loading"></div>}
        <div className="col-xl-10 mx-xl-auto">
          <div className="card card-raised mb-2">
            <div className="card-body p-4">
              <p>Are you sure you want to cancel this appointment?</p>
             
              <div className="d-flex justify-content-end mt-2">
                <Button variant="secondary" onClick={onRequestClose}>
                  Close
                </Button>
                <Button
                  variant="danger"
                  onClick={handleConfirmCancel}
                  style={{ marginLeft: '10px' }}
                >
                    Confirm
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default CancelDoctorAppointment;
